import React from 'react';
import PropTypes from "prop-types";

import CountryFlag from "../../../components/CountryFlag";

import {BookingPrice, TextIconListElement} from "../BookingComponents";

import Typography from "@mui/material/Typography";

import LabelIcon from "@mui/icons-material/Label";
import EmailIcon from "@mui/icons-material/Email";
import PeopleIcon from "@mui/icons-material/People";
import PetsIcon from "@mui/icons-material/Pets";
import PublicIcon from '@mui/icons-material/Public';
import ReceiptIcon from "@mui/icons-material/Receipt";
import Grid from "@mui/material/Grid";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import EuroIcon from "@mui/icons-material/Euro";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import {
    CANCELLATION_POLICIES_REGISTRY,
    TOURIST_TAX_POLICIES_REGISTRY
} from "../../../services/booking_conditions/enums";
import {timeString} from "../../../services/date/formatters";
import {isValidDateObject} from "../../../services/date/validators";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel/FormControlLabel";
import GeoService from "../../../services/geo";
import BookingItem from "./BookingItem";


const StepSummary = (props) => {
    const {formik, disableSendConfirmationEmail} = props;

    const {
        name,
        surname,
        email,
        hostNotes,
        deposit,
        adults,
        children,
        petsNumber,
        nationality,
        bookingCondition,
        arrival,
        departure
    } = formik.values;

    const {
        cancellationPolicy,
        touristTaxPolicy,
        checkInFrom,
        checkOutBefore
    } = bookingCondition || {};

    const cancellationPolicyText = CANCELLATION_POLICIES_REGISTRY.find(policy => policy.value === cancellationPolicy)?.label || 'Non specificata';
    const touristTaxPolicyText = TOURIST_TAX_POLICIES_REGISTRY.find(policy => policy.value === touristTaxPolicy)?.label || 'Non specificata';
    const checkInFromText = isValidDateObject(checkInFrom) ? timeString(checkInFrom) : 'Non specificato';
    const checkOutBeforeText = isValidDateObject(checkOutBefore) ? timeString(checkOutBefore) : 'Non specificato';

    const nameAndSurname = [surname, name].filter(x => !!x)
    const fullName = nameAndSurname.length > 0 ? nameAndSurname.join(' ') : null;

    const nationalityObj = GeoService.COUNTRIES.find(c => c.code === nationality);

    let peopleLabel = `${adults} ${adults === 1 ? 'adulto' : 'adulti'}`;
    if (children > 0) {
        peopleLabel += `, ${children} ${children === 1 ? 'bambino' : 'bambini'}`;
    }

    const totalPrice = formik.values.bookingItems.reduce(
        (acc, x) => {
            const price = x.price ? parseFloat(x.price) : 0;
            return acc + price;
        }, 0);

    const totalPayed = formik.values.depositPayed ? (formik.values.deposit || 0) : 0;

    return (
        <>
            <Typography variant='h6' color='primary' fontWeight="normal" sx={{mb: 1}}>
                Riepilogo
            </Typography>
            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    {
                        fullName && <TextIconListElement iconComponent={LabelIcon} text={fullName}/>
                    }

                    {
                        email && <TextIconListElement iconComponent={EmailIcon}
                                                      text={email}/>
                    }

                    {
                        nationalityObj && <TextIconListElement iconComponent={PublicIcon}
                                                               text={
                                                                   <>
                                                                       {`${nationalityObj.label} `}
                                                                       <CountryFlag code={nationalityObj.code}/>
                                                                   </>
                                                               }/>
                    }

                    <TextIconListElement iconComponent={PeopleIcon} text={peopleLabel}/>

                    {
                        petsNumber > 0 &&
                        <TextIconListElement iconComponent={PetsIcon}
                                             text={petsNumber === 1 ? "1 Animale domestico" : `${petsNumber} Animali domestici`}/>
                    }

                    <TextIconListElement iconComponent={ReceiptIcon}
                                         text={`Caparra concordata ${deposit ? deposit.toFixed(2) : 0} €`}/>

                    {
                        hostNotes && <Typography fontWeight="light" sx={{mt: 1}}>
                            {hostNotes}
                        </Typography>
                    }
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextIconListElement iconComponent={EventBusyIcon}
                                         text={`Politica di cancellazione: ${cancellationPolicyText}`}/>
                    <TextIconListElement iconComponent={EuroIcon} text={`Tassa di soggiorno: ${touristTaxPolicyText}`}/>
                    <TextIconListElement iconComponent={AccessTimeIcon} text={`Check-in dalle: ${checkInFromText}`}/>
                    <TextIconListElement iconComponent={AccessTimeIcon}
                                         text={`Check-Out entro le: ${checkOutBeforeText}`}/>
                </Grid>
            </Grid>

            <Typography variant='h6' color='primary' fontWeight="normal" sx={{my: 2}}>
                Strutture prenotate
            </Typography>

            {
                formik.values.bookingItems.map((x, i) => <BookingItem key={i}
                                                                      accommodationName={x.accommodation.name}
                                                                      name={x.name}
                                                                      arrival={arrival}
                                                                      departure={departure}
                                                                      price={x.price}/>)
            }

            <BookingPrice price={totalPrice} payed={totalPayed} balance={totalPrice - totalPayed} sx={{my: 3}}/>

            <Typography variant='h6' color='primary' fontWeight="normal" sx={{mb: 1}}>
                Azioni
            </Typography>

            <FormControlLabel
                control={
                    <Switch
                        name="bookingConfirmationDocument.sendEmailAfterCreate"
                        color="primary"
                        checked={formik.values.bookingConfirmationDocument?.sendEmailAfterCreate}
                        onChange={formik.handleChange}
                        disabled={disableSendConfirmationEmail}/>
                }
                label={formik.values.bookingConfirmationDocument?.sendEmailAfterCreate ? "Invia l'email di conferma all'ospite" : "Non inviare l'email di conferma all'ospite"}
            />
        </>
    );
};

StepSummary.propTypes = {
    formik: PropTypes.object.isRequired,
};

export default StepSummary;